import { VisualizationProps } from "./Visualization";

export type ColorPalette =
  | "categorical"
  | "scope"
  | "ordinal_green"
  | "ordinal_blue"
  | "light_blue"
  | "forest_green";

export const colorPalettes: Record<
  ColorPalette,
  { normal: string[]; light: string[]; font: string[] }
> = {
  categorical: {
    normal: ["#F6BD16", "#6DC8EC", "#E8684A", "#5B8FF9", "#5AD8A6", "#5D7092"],
    light: ["#fbe5a2", "#c5e9f7", "#f6c3b7", "#bdd2fd", "#e5edfe", "#bdc5d5"],
    font: ["#434343", "#434343", "#434343", "#434343", "#434343", "#434343"],
  },
  scope: {
    normal: ["#5D7092", "#E8684A", "#F6BD16"],
    light: ["#829ac5", "#e68c78", "#f1d06b"],
    font: ["#fff", "#fff", "#434343"],
  },
  forest_green: {
    normal: ["#13260F", "#516F4A", "#669959", "#77B269", "#B7E0AD", "#EBF6E8"],
    light: ["#13260F", "#516F4A", "#669959", "#77B269", "#B7E0AD", "#EBF6E8"],
    font: ["#fff", "#fff", "#fff", "#fff", "#fff"],
  },
  ordinal_green: {
    normal: ["#094308", "#598F59", "#99C291", "#BCD5B9", "#E4EEE3"],
    light: ["#0d620c", "#bad4ba", "#d6e7d3", "#e4eee3", "f4f8f4"],
    font: ["#fff", "#fff", "#fff", "#fff", "#fff"],
  },
  ordinal_blue: {
    normal: ["#002329", "#00474F", "#08979C", "#13C2C2", "#5CDBD3", "#E6FFFB"],
    light: ["#002329", "#00474F", "#08979C", "#13C2C2", "#5CDBD3", "#E6FFFB"],
    font: ["#fff", "#fff", "#fff", "#fff", "#fff", "#fff"],
  },
  light_blue: {
    normal: ["#B5F5EC"],
    light: ["#B5F5EC"],
    font: ["#434343"],
  },
};

export default function useVisualization({ format, colorPalette }: VisualizationProps) {
  const formatLabel = (value: number, excludeUnit?: boolean) => {
    if (format) return format(value, excludeUnit);
    return String(value);
  };

  const colors = colorPalette
    ? colorPalettes[colorPalette]["normal"]
    : colorPalettes["categorical"]["normal"];

  const lightColors = colorPalette
    ? colorPalettes[colorPalette]["light"]
    : colorPalettes["categorical"]["light"];

  const fontColors = colorPalette
    ? colorPalettes[colorPalette]["font"]
    : colorPalettes["categorical"]["font"];

  return {
    formatLabel,
    colorPalette: colors,
    lightColorPalette: lightColors,
    fontColorPalette: fontColors,
  };
}
